// leave off @2x/@3x
const images = {
    
}

export default images
